import store from 'store'
import { TenantInfo } from '@antegma/accallio-cloud-profile-api'
import actions from './actions'

export type TTenantState = {
  current?: TenantInfo
  available: TenantInfo[]
}

const STORED_STATE = (initialState: TTenantState): TTenantState => {
  const storedState = store.get('app.tenant')
  if (storedState) {
    return JSON.parse(storedState) as TTenantState
  }
  return initialState
}

const initialState = {
  ...STORED_STATE({
    available: [],
  }),
}

export default function tenantReducer(state: TTenantState = initialState, action: any) {
  switch (action.type) {
    case actions.SET_STATE:
      return {
        ...state,
        ...action.payload,
      }
    case actions.GET_STATE:
      return state
    default:
      return state
  }
}
